import "@/index.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import Home from "@/pages/Home";
import Marches from "@/pages/Marches";
import Expertises from "@/pages/Expertises";
import Approche from "@/pages/Approche";
import Blog from "@/pages/Blog";
import APropos from "@/pages/APropos";
import Pays from "@/pages/Pays";
import Contact from "@/pages/Contact";
import Connexion from "@/pages/Connexion";
import Inscription from "@/pages/Inscription";
import EspaceClient from "@/pages/EspaceClient";
import NousRejoindre from "@/pages/NousRejoindre";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      // Wait for section to mount, then smooth-scroll to the anchor
      const t = setTimeout(() => {
        const el = document.getElementById(hash.slice(1));
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        else window.scrollTo(0, 0);
      }, 120);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

const ProtectedRoute = ({ children }) => {
  const { user, ready } = useAuth();
  if (!ready) {
    return <div className="min-h-screen bg-night flex items-center justify-center text-gold">Chargement…</div>;
  }
  return user ? children : <Navigate to="/connexion" replace />;
};

function App() {
  return (
    <AuthProvider>
      <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
        <div className="App bg-night min-h-screen">
          <BrowserRouter>
            <ScrollToTop />
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/marches" element={<Marches />} />
                <Route path="/expertises" element={<Expertises />} />
                <Route path="/approche" element={<Approche />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/a-propos" element={<APropos />} />
                <Route path="/pays" element={<Pays />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/connexion" element={<Connexion />} />
                <Route path="/inscription" element={<Inscription />} />
                <Route path="/espace-client" element={<ProtectedRoute><EspaceClient /></ProtectedRoute>} />
                <Route path="/nous-rejoindre" element={<NousRejoindre />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
              </Routes>
            </main>
            <Footer />
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </div>
      </ReactLenis>
    </AuthProvider>
  );
}

export default App;
